var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('side-bar',{attrs:{"sidebar-item-color":_vm.sidebarBackground,"sidebar-background-image":_vm.sidebarBackgroundImage}},[_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"}),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Common',
          icon: 'supervised_user_circle'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Status',
            icon: 'info',
            path: '/common_page'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'NG Word',
            icon: 'edit_note',
            path: '/ng_word'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Salesidol',
          icon: 'supervised_user_circle'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Salesidol',
            icon: 'perm_phone_msg',
            path: '/salesidol_table'
          }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Mayai',
          icon: 'supervised_user_circle'
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Mayai Customer List',
            icon: 'voicemail',
            path: '/mayai_customer_list'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Mayai Reports',
            icon: 'article',
            path: '/mayai_reports'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Mayai Reports (Beta)',
            icon: 'article',
            path: '/mayai_daily_reports'
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Number manager',
            icon: 'phone',
            path: '/number_pool'
          }}})],1)],1)],2),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('dashboard-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }